import { Comparator } from '@clr/angular';

export class StorageComparator implements Comparator<JSON> {

    private fieldToSort: string;
    private fieldType: string;

    constructor(field: string, fieldType?: string) {
        this.fieldToSort = field;
        if (fieldType) {
            this.fieldType = fieldType;
        } else {
            this.fieldType = 'number';
        }

    }

    compare(a, b) {
        if (this.fieldType === 'number') {
            return a[this.fieldToSort] - b[this.fieldToSort];
        }
        if (this.fieldType === 'date') {
            return new Date(a[this.fieldToSort]).getTime() - new Date(b[this.fieldToSort]).getTime();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/restore-points/restore-point-storage-comparator.ts